import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { SearchCategoryType } from 'model/gloabalSearch.model';
import RoutePaths from 'routes/RoutePaths';
import { BusinessesService } from 'service/businesses.service';
import { useAppDispatch } from 'store/hooks';
import { setAdminSearchModal } from 'store/slices/businessesSlice';
import zeplinColor from 'theme/Color';
import Logo from '../../Logo';
import { container, logoContainer, recentOpenContent, textContainer } from './styles';

dayjs.extend(relativeTime);

const content: Partial<Record<SearchCategoryType, (data: any) => ReactNode>> = {
  business: ({ name, logo, website }) => (
    <>
      <Box sx={{ width: '40px', height: '40px' }}>
        <Logo logo={logo} />
      </Box>
      <Box sx={{ ...textContainer }}>
        <Typography variant='responsiveButtonMedium'>{name}</Typography>
        <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
          {website}
        </Typography>
      </Box>
    </>
  ),
  recent: ({ name, clickedAt, logo }) => {
    return (
      <>
        <Box sx={{ ...logoContainer }}>
          <Logo logo={logo} />
        </Box>
        <Box sx={{ ...recentOpenContent }}>
          <Typography variant='responsiveButtonMedium'>{name}</Typography>
        </Box>
        <Typography variant='responsiveButtonMedium'>{dayjs(clickedAt).fromNow()}</Typography>
      </>
    );
  },
};

const Result = ({ type, data }: { type: SearchCategoryType; data: any }) => {
  const renderContent = content[type];
  const dispatch = useAppDispatch();

  const handleResultClick = async () => {
    await BusinessesService.addZoomInfoRecentSearch(data);
    dispatch(setAdminSearchModal(false));
  };

  return (
    <Link
      to={`${RoutePaths.ZoomInfo}/${data.id}`}
      style={{ textDecoration: 'none' }}
      onClick={() => handleResultClick()}
    >
      <Box sx={{ ...container }}>
        {typeof renderContent === 'function' ? renderContent(data) : null}
      </Box>
    </Link>
  );
};
export default Result;
